export default "__VITE_ASSET__5da9d730__"